import $ from 'jquery';
import Parallax from 'parallax-js';
import { Foundation } from './lib/foundation-explicit-pieces';
import './components/_carousel';
import './components/_tabs';
import './components/_lang';
import './components/_press';

$('.offcanvas_item_header').click(function () {
  if (Foundation.MediaQuery.only('small')) {
    $(this).toggleClass('opened');
    $(this).next().slideToggle('fast');
  }
});

$('.featured_inner--main').click(function () {
  location.href = '/press/';
});

$('.team_member--secondary').click(function () {
  const name = $('.team_member_name', this).text();
  const bio = $(this).data('bio');

  $('#member .reveal_photo img').attr({
    src: `/assets/img/team/${name
      .split(' ')[0]
      .replace(',', '')
      .toLowerCase()}.png`,
    alt: name,
  });
  $('#member .reveal_header').text(name);
  $('#member .reveal_descr').text(bio);
});

// Parallax
const scene = document.querySelector('.cfx_parallax');
if (scene) new Parallax(scene);
